export const DashboardHeaderConstants = {
  cloudSummary: 'Environment Summary', // Foundation Summary //Cloud Assessment
  discoverAccess: 'Cloud Strategy', //'Foundation Strategy',//'Cloud Strategy', // Foundation Assessment
  buildDeploy: 'Environment Build', //'Design & Build', // Build Foundation
  migrateModernize: 'Environment Runways', //'Modernization', // Foundation Readiness
  operate: 'Site Reliability Engineering', // Site reliability Engineering
  securityGovernance: 'Security & Governance', // Security & Governance
  buildDeployTest: 'Build, Deploy & Test',
  modernization: 'Environment Runways', //'Modernization',
  guardrails: 'Guardrails',
  assess: 'Assess',
  migrate: 'Migrate',
  transform: 'Transform',
  test: 'Test',
  manage: 'Manage',
  deliver: 'Deliver',
  viewMore: 'View More',
  viewAll: 'View All',
  more: 'More',
  observability: 'Observability',
  chaosEngineering: 'Chaos Engineering',
  reliabilityMetrics: 'Reliability Metrics',
  aiEngine: 'AI Engine',
};
